import { ADD_PATH, DETAIL_PATH, EDIT_PATH, LIST_PATH, MAP_PATH, NURSERY_PATH, PROMOTION_PATH, SPHERE_PATH } from "../properties/path.property";
import { HeaderButton } from "../../models/header/headerbutton.model";
import { GenericUtils } from "./generic.utils";
import { HEADER_BUTTON_COLOR_1, HEADER_BUTTON_COLOR_2, HEADER_BUTTON_COLOR_5, HEADER_BUTTON_TYPE_NEW, HEADER_BUTTON_TYPE_OTHER, HEADER_BUTTON_WIDTH_3 } from "../properties/header.property";
import { GenericService } from "../../services/generic.services";
import * as i0 from "@angular/core";
import * as i1 from "./generic.utils";
import * as i2 from "../../services/generic.services";
var HeaderUtils = /** @class */ (function () {
    function HeaderUtils(genericUtils, genericService) {
        var _this = this;
        this.genericUtils = genericUtils;
        this.genericService = genericService;
        this.saveButton = new HeaderButton(HEADER_BUTTON_TYPE_OTHER, "HEADER_COMPONENT_LABEL_SAVE", HEADER_BUTTON_COLOR_1, HEADER_BUTTON_COLOR_2, null, "1.375rem", "fa-floppy-o", HEADER_BUTTON_WIDTH_3, function () {
            _this.genericService.onSaveCalled.emit();
        }, true);
        this.backButton = new HeaderButton(HEADER_BUTTON_TYPE_OTHER, "HEADER_COMPONENT_LABEL_BACK", HEADER_BUTTON_COLOR_2, HEADER_BUTTON_COLOR_5, HEADER_BUTTON_COLOR_5, "1.375rem", "fa-arrow-left", HEADER_BUTTON_WIDTH_3, function () {
            _this.genericService.onGoBackCalled.emit();
        });
        this.newButton = new HeaderButton(HEADER_BUTTON_TYPE_NEW, "HEADER_COMPONENT_LABEL_NEW", HEADER_BUTTON_COLOR_1, HEADER_BUTTON_COLOR_2, null, "1.375rem", "fa-plus", HEADER_BUTTON_WIDTH_3, function () {
            _this.genericService.onNewCalled.emit();
        });
        this.deleteButton = new HeaderButton(HEADER_BUTTON_TYPE_OTHER, "HEADER_COMPONENT_LABEL_DELETE", HEADER_BUTTON_COLOR_5, HEADER_BUTTON_COLOR_2, null, "1.375rem", "fa-trash", HEADER_BUTTON_WIDTH_3, function () {
            _this.genericService.onDeleteCalled.emit();
        });
        this.editButton = new HeaderButton(HEADER_BUTTON_TYPE_OTHER, "HEADER_COMPONENT_LABEL_EDIT", HEADER_BUTTON_COLOR_1, HEADER_BUTTON_COLOR_2, null, "1.375rem", "fa-pencil", HEADER_BUTTON_WIDTH_3, function () {
            _this.genericService.onEditCalled.emit();
        }, true);
    }
    HeaderUtils.prototype.getElements = function (currentPath) {
        var headerButtons = [];
        // user
        if (this.genericUtils.isPath(currentPath, NURSERY_PATH + "/" + DETAIL_PATH)
            || this.genericUtils.isPath(currentPath, NURSERY_PATH + "/" + EDIT_PATH)
            || this.genericUtils.isPath(currentPath, NURSERY_PATH + "/" + SPHERE_PATH)
            || this.genericUtils.isPath(currentPath, NURSERY_PATH + "/" + MAP_PATH)
            || this.genericUtils.isPath(currentPath, NURSERY_PATH + "/" + ADD_PATH)
            || this.genericUtils.isPath(currentPath, PROMOTION_PATH + "/" + EDIT_PATH)
            || this.genericUtils.isPath(currentPath, PROMOTION_PATH + "/" + ADD_PATH)) {
            headerButtons.push(this.backButton);
        }
        if (this.genericUtils.isPath(currentPath, PROMOTION_PATH + "/" + LIST_PATH)
            || this.genericUtils.isPath(currentPath, NURSERY_PATH + "/" + LIST_PATH)) {
            headerButtons.push(this.newButton);
        }
        return headerButtons;
    };
    HeaderUtils.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HeaderUtils_Factory() { return new HeaderUtils(i0.ɵɵinject(i1.GenericUtils), i0.ɵɵinject(i2.GenericService)); }, token: HeaderUtils, providedIn: "root" });
    return HeaderUtils;
}());
export { HeaderUtils };
